<template>
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="sc-dhKdcB iwWLpo">
    <path d="m20.375 6.625-11 11-3-3 11-11 3 3Zm-15 9-1.75 4.25.25.25.25.25 4.25-1.75-3-3Z" fill="#121212"></path>
  </svg>
</template>
